import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { notification } from 'antd';
import moment from 'moment';
import get from 'lodash/get';
import { modalHide, modalShow } from '../store/modal/actions';
import { isOpen } from '../store/modal/selectors';
import DebugModal from '../components/molecules/DebugModal';
import { resourceDetailReadRequest } from '../store/resource/actions';

class DebugModalContainer extends Component {
  scriptUrl = null;

  constructor(props) {
    super(props);
    this.scriptUrl = this.getScriptUrl();
  }

  state = {
    cacheDuration: null,
    ui: {},
    api: {},
    loading: false,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.visible && !prevProps.visible) {
      this.refresh();
    }

    if (
      (!get(prevState, 'ui.date') || !get(prevState, 'ui.currentCache')) &&
      get(this.state, 'ui.currentCache') &&
      get(this.state, 'ui.date')
    ) {
      this.validateCache();
    }
  };

  getScriptUrl = () => {
    const scripts = document.getElementsByTagName('script');
    const lastScript = scripts[scripts.length - 1];
    return lastScript.src;
  };

  fetchCurrentScript = () => {
    const req = new XMLHttpRequest();
    req.open('HEAD', this.scriptUrl, false);
    req.send(null);
    if (req.status === 200) {
      return req.getResponseHeader('Last-Modified');
    }
    return 'Could not retrieve cache status';
  };

  refresh = () => {
    const { getApiDebug } = this.props;
    const promises = ['/release-info.json', '/release-details.json'].map(url =>
      fetch(url).then(y => y.json())
    );

    Promise.all([this.fetchCurrentScript()])
      .then(r => this.setState({ ui: { currentCache: r[0], ...this.state.ui } }))
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve cache status',
          duration: 0,
        })
      );

    getApiDebug()
      .then(results => {
        this.setState({ api: results });
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve api status.',
          duration: 0,
        })
      );

    Promise.all([...promises])
      .then(results => {
        this.setState({
          loading: false,
          ui: { ...this.state.ui, ...results[0], ...results[1] },
        });
      })
      .catch(e =>
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve UI status.',
          duration: 0,
        })
      );
  };

  validateCache = () => {
    const api = moment(get(this.state, 'ui.date'));
    const ui = moment(get(this.state, 'ui.currentCache'));
    this.setState({
      cacheDuration: ui.diff(api),
    });
  };

  render = () => <DebugModal {...this.state} {...this.props} />;
}

const mapStateToProps = ({ modal }) => ({
  visible: isOpen(modal, 'debug-info'),
});

const mapDispatchToProps = dispatch => ({
  getApiDebug: () => dispatch(resourceDetailReadRequest('debug')),
  show: () => dispatch(modalShow('debug-info')),
  onCancel: () => dispatch(modalHide('debug-info')),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DebugModalContainer);
